import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, useFormikContext } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
  FormGroup,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { ReactstrapInput } from "reactstrap-formik";

import * as Yup from "yup";

import FormHelpers from "../../helpers/FormHelpers";
import ScrollToFieldError from "./Validation/ScrollToFieldError";
import InfoTooltip from "../UI/Progress/InfoTooltip";

import { configuratorActions } from "../../store/configurator-slice";
import { sendCartData } from "../../store/configurator-actions";

function RequestForm() {
  const dispatch = useDispatch();

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;

  console.log(requestDetails);

  const isUpdating = requestDetails.Id;

  const addingToCart = useSelector((state) => state.configurator.AddingToCart);

  // add to cart if no card
  useEffect(() => {
    if (addingToCart) {
      let currentCart = { ...requestDetails };
      dispatch(sendCartData(currentCart));

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [dispatch, addingToCart]);

  let defaultIntentionConfig = {
    placeholder: "",
    rows: 5,
    cols: 32,
    max: 1000,
  };

  let prices = currentRequest.DonationAmounts.split("|");

  const formRef = useRef(null);

  const [intentionConfig, setIntentionConfig] = useState(
    defaultIntentionConfig
  );

  const intentionRef = useRef(null);

  const validationRules = {
    intention: Yup.string().required("Required"),
    amount: Yup.string().required("Please select an amount"),
    customAmount: Yup.number()
      .typeError("Please enter a donation amount of at least $5.00.")
      .when("amount", (amount) => {
        if (amount == "other")
          return Yup.number()
            .typeError("Please enter a donation amount of at least $5.00.")
            .min(5, "Please enter a donation amount of at least $5.00.")
            .required("Please enter a donation amount of at least $5.00.");
      }),
  };

  let donationAmount = "";
  let donationCustomAmount = "";
  let defaultPriceFound = false;

  prices.forEach((price) => {
    if (Number(price) == Number(requestDetails.OfferingAmount)) {
      defaultPriceFound = true;
    }
  });

  if (defaultPriceFound) {
    donationAmount = String(Number(requestDetails.OfferingAmount).toFixed(2));
  } else {
    if (requestDetails.OfferingAmount) {
      donationAmount = "other";
      donationCustomAmount = String(
        Number(requestDetails.OfferingAmount).toFixed(2)
      );
    }
  }

  const formSchema = Yup.object().shape(validationRules);

  function formSubmitHandler(values) {
    // if request is a no card, add to cart right now and move to last step
    dispatch(configuratorActions.setRequest(values));
    FormHelpers.scrollToTop();
  }

  return (
    <div className="cfg-input-form cfg-request" data-step="request">
      <Formik
        initialValues={{
          intention: requestDetails.Intention,
          amount: donationAmount,
          customAmount: donationCustomAmount,
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form className="text-start">
            <ScrollToFieldError />
            <Container className="cfg-form-section">
              <Row className="mb-3">
                <Col xs="12">
                  <h4 className="required">
                    Please list your names – separated by a comma.
                  </h4>
                  <FormGroup>
                    <Input
                      name="intention"
                      type="textarea"
                      id="intention"
                      ref={intentionRef}
                      datamax={intentionConfig.max}
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      value={values.intention}
                      rows={intentionConfig.rows}
                      cols={intentionConfig.cols}
                      className="cfg-intention-input parse-new-lines"
                      placeholder={intentionConfig.placeholder}
                      onKeyUp={FormHelpers.handleMultilineKeyUp}
                      onKeyDown={FormHelpers.handleMultilineKeyDown}
                      onPaste={FormHelpers.handleMultilineUpdate}
                      onChange={(e) => {
                        FormHelpers.handleMultilineUpdate(e);
                        handleChange(e);
                      }}
                      onBlur={(e) => {
                        FormHelpers.handleMultilineUpdate(e);
                        FormHelpers.cleanupEmptyLines(e, values, 'intention');
                        handleBlur(e);
                        
                      }}
                      invalid={Boolean(
                        touched["intention"] && errors["intention"]
                      )}
                    />
                    {touched["intention"] && errors["intention"] ? (
                      <FormFeedback>{errors["intention"]}</FormFeedback>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="12">
                  <div className="mb-3">
                    <h4 className="required">
                      My offering to support the Capuchin missionaries is:
                    </h4>

                    {prices.map((price) => (
                      <div className="form-check" key={price}>
                        <label>
                          <Field
                            type="radio"
                            name="amount"
                            value={price.toString()}
                            onChange={handleChange}
                          />
                          ${price}
                        </label>
                      </div>
                    ))}

                    <div className="form-check">
                      <label>
                        <Field
                          type="radio"
                          name="amount"
                          value="other"
                          onChange={handleChange}
                        />
                        Other
                      </label>
                    </div>

                    {errors.amount && touched.amount && (
                      <div className="invalid-feedback">{errors.amount}</div>
                    )}

                    {values.amount === "other" && (
                      <div>
                        <label>
                          $ <Field type="text" name="customAmount" />
                        </label>
                      </div>
                    )}

                    {errors.customAmount && touched.customAmount && (
                      <div className="invalid-feedback">
                        {errors.customAmount}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              {/* <DebugOutput
                errors={errors}
                values={FormHelpers.getValues(values)}
              /> */}
            </Container>
            <Button
              type="submit"
              size="sm"
              color="primary"
              className="float-end"
            >
              {isUpdating ? "Update Cart" : "Add to Cart"}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default RequestForm;
